import axios from 'axios';
import Jsona from 'jsona';

const url = process.env.VUE_APP_API_BASE_URL;
const jsona = new Jsona();

function add(status) {
    const payload = jsona.serialize({
        stuff: status,
        includeNames: null
    });

    const options = {
        headers: {
            'Accept': 'application/vnd.api+json',
            'Content-Type': 'application/vnd.api+json',
        }
    };

    return axios.post(`${url}/device-licence-status/${status.device_id}`, payload, options)
        .then(response => {
            return jsona.deserialize(response.data);
        });
}

function assignLicence(status) {
    const payload = jsona.serialize({
        stuff: status,
        includeNames: null
    });

    const options = {
        headers: {
            'Accept': 'application/vnd.api+json',
            'Content-Type': 'application/vnd.api+json',
        }
    };

    return axios.post(`${url}/device-assign-licence/${status.device_id}`, payload, options)
        .then(response => {
            return jsona.deserialize(response.data);
        });
}

export default {
    add,
    assignLicence
};